





















































































import { Component, Vue } from "vue-property-decorator";
import AuthService from "@/services/AuthService";
import PolicyAcceptancePayload from "@/dto/auth/PolicyAcceptancePayload";
import RouteNames from "@/router/RouteNames";
import { namespace } from "vuex-class";
import Auth from "@/state/Auth";
import PortalCheckbox from "@/components/new_style_components/PortalCheckbox.vue";

const AuthStore = namespace("Auth");

@Component({
  components: {
    PortalCheckbox
  }
})
export default class PolicyAcceptance extends Vue {
  @AuthStore.Action
  private loginSuccess!: (user: any) => void;

  private termsAccepted = true;
  private privacyAccepted = true;
  private marketingConsent = true;
  private loading = false;
  private error: string | null = null;
  private uiContext: any = null;

  created() {
      if (this.$route.params.uiContext) {
          try {
              this.uiContext = this.$route.params.uiContext;
          } catch (e) {
              console.error("Failed to parse uiContext", e);
          }
      } else if (this.$route.query.uiContext) {
           try {
              this.uiContext = JSON.parse(atob(this.$route.query.uiContext as string));
          } catch (e) {
              console.error("Failed to parse uiContext payload from query", e);
          }
      }
  }

  async submit() {
    const isValid = await this.$validator.validateAll();
    if (!isValid) {
      this.error = this.$t("auth.policy_acceptance.validation_error") as string;
      return;
    }

    this.loading = true;
    this.error = null;

    try {
      const payload = new PolicyAcceptancePayload(
        this.termsAccepted,
        this.privacyAccepted,
        this.marketingConsent,
        this.uiContext ? JSON.stringify(this.uiContext) : null
      );

      await AuthService.acceptPolicy(payload);

      const currentUser = Auth.getUser;
      if (currentUser) {
          currentUser.hasActualRequiredPoliciesAcceptance = true;
          Auth.setUser(currentUser);
      }

      if (this.uiContext && this.uiContext.name) {
        this.$router.push(this.uiContext);
      } else {
        this.$router.push({ name: RouteNames.HOME });
      }

    } catch (err: any) {
      this.error = err.response?.data?.message || err.message || "An error occurred";
    } finally {
      this.loading = false;
    }
  }
}
